(ns app.front.state-machine)

(defn- next-state
  [fsm current-state transition]
  (get-in fsm [current-state transition]))

(defn- extract-event [event-key-or-vector]
  (if (keyword? event-key-or-vector)
    event-key-or-vector
    (first event-key-or-vector)))

(defn make-update-next-state
  "Make a function that advances the app-db from one state to another, either
  with a re-frame event vector or an event identifier keyword.

  state-machine is a map such as
  {nil      {:transition-1 :state-1} ; nil is the initial state
   :state-1 {:transition-2 :state-3
             :transition-3 :state-4}

  store-path is a vector path for where in the state the state is stored.

  The function returned can be used directly as (ret-fn db ::transition) or
  registered as a re-frame db handler as (rf/reg-event-db ::event ret-fn)."
  [state-machine store-path]
  (fn [db event]
    (if-let [new-state (next-state state-machine
                                   (get-in db store-path)
                                   (extract-event event))]
      (assoc-in db store-path new-state)
      db)))
